import { SecurityRead } from 'api';

type UnderlyingSecurityFields = Pick<SecurityRead, 'underlying_security' | 'underlying_security_ref'>;

export const syncGroupedSecurityUnderlying = (
  child: UnderlyingSecurityFields,
  group: UnderlyingSecurityFields | undefined
): UnderlyingSecurityFields => ({
  underlying_security: group ? group.underlying_security : child.underlying_security,
  underlying_security_ref: group ? group.underlying_security_ref : child.underlying_security_ref,
});
